import React from 'react'

const FilledEclipseIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <circle cx='12' cy='12' r='11' stroke='#007DFB' strokeWidth='2' />
      <circle cx='12' cy='12' r='8' fill='#007DFB' />
    </svg>
  )
}

export default FilledEclipseIcon
